// react-intl locale -> the travel kit's `lang` token field.
export const TRAVEL_KIT_LANG_BY_LOCALE: Record<string, string> = {
  en: 'en',
  zh: 'sc',
  'zh-Hant-HK': 'tc'
};
